<template>
    <div>
        <v-snackbar timeout="6000" v-model="showSnack" top right :color="showCol">
            {{ showMsg }}
        </v-snackbar>
    </div>
</template>
<script>
import { VSnackbar } from 'vuetify/lib';

export default {
    name: "Snack",
    components:{ VSnackbar },
    props:{
        snack: Boolean, 
        snackMsg: String,
        snackCol: String
    },
    computed:{
        showSnack:{
            get(){
                return this.snack;
            },
            set(val){
                this.$emit('v-snackbar', val);
            }
        },
        showMsg(){
            return this.snackMsg;
        },
        showCol(){
            return this.snackCol;
        }
    }
}
</script>

